import ChartJS from "chart.js/auto"
import {
  CategoryScale,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from "chart.js"
import { useSelector } from "react-redux"
import { getConf } from "../../../store/features/confSlice"
import { useEffect, useState } from "react"
import axios from "axios"
import { Line } from "react-chartjs-2"
import moment from "moment"
import "moment/locale/es"
import { Button, Grid } from "@mui/material"
import { MyDateInput } from "../../inputs/MyDateInput"
import saveAs from "file-saver"
import { getAuth } from "../../../store/features/authSlice"

/**
 * Tipo: Line
 * Detalle: Muestra la cantidad de interacciones (like, save) por cada día (últimos 7 dias)
 */

const { REACT_APP_API_ROUTE: API_ROUTE } = process.env
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
)

export const InteractionsForDayChart = () => {
  const conf = useSelector(getConf)
  const auth = useSelector(getAuth)
  const [report, setReport] = useState([])
  const [isLoading, setLoading] = useState(true)
  const [filters, setFilters] = useState({
    startDate: moment().subtract(1, "month").format("YYYY-MM-DD"),
    finishDate: moment().format("YYYY-MM-DD"),
  })
  const title = "Interacciones con todos los posts por día"

  useEffect(() => {
    getReport()
  }, [filters])

  const getReport = async () => {
    try {
      const endpoint = `/report/chart/interactions-for-day?start-date=${filters.startDate}&finish-date=${filters.finishDate}`
      const { data } = await axios.get(API_ROUTE + endpoint, {
        headers: { Authorization: auth.data.jwtToken },
      })
      setReport(data)
      console.table(data)
      setLoading(false)
    } catch (err) {
      console.log(err)
      console.log("No se pudo obtener los datos del reporte")
    }
  }

  const handleChange = (e) => {
    const name = e.target.name
    const value = e.target.value

    console.log(name, value)

    switch (name) {
      case "startDate":
      case "finishDate":
        setFilters({ ...filters, [name]: value.substring(0, 10) })
        break
      default:
        setFilters({ ...filters, [name]: value })
    }
  }

  const download = () => {
    const head = "fecha;me gusta;guardado\n"
    const body = report
      .map((item) => {
        const date = item.date
        const likes = item.data.find(
          (e) => e.subscriptionMode === 2
        ).interactions
        const saves = item.data.find(
          (e) => e.subscriptionMode === 1
        ).interactions
        return date + ";" + likes + ";" + saves
      })
      .join("\n")
    const file = new Blob([head + body])
    saveAs(file, `${Date.now()}.txt`)
  }

  if (isLoading) return <></>

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: title,
      },
    },
  }

  const data = {
    labels: report.map((item) => moment(item.date).format("dddd DD [de] MMMM")),
    datasets: [
      {
        label: "Cantidad de likes",
        data: report.map(
          (item) => item.data.find((e) => e.subscriptionMode === 2).interactions
        ),
        borderColor: conf.data.colors.find((item) => item.id === 3).bg,
        backgroundColor: conf.data.colors.find((item) => item.id === 3).bg,
      },
      {
        label: "Cantidad de guardados",
        data: report.map(
          (item) => item.data.find((e) => e.subscriptionMode === 1).interactions
        ),
        borderColor: conf.data.colors.find((item) => item.id === 14).bg,
        backgroundColor: conf.data.colors.find((item) => item.id === 14).bg,
      },
    ],
  }

  return (
    <>
      <Line options={options} data={data} />
      <Grid container spacing={1} my={1}>
        <Grid item xs={4}>
          <MyDateInput
            label="Desde"
            name="startDate"
            date={filters.startDate}
            handleChangeElement={handleChange}
          />
        </Grid>
        <Grid item xs={4}>
          <MyDateInput
            label="Hasta"
            name="finishDate"
            date={filters.finishDate}
            handleChangeElement={handleChange}
          />
        </Grid>
        <Grid item xs={4}>
          <Button
            fullWidth
            variant="outlined"
            size="large"
            sx={{ height: 55 }}
            onClick={download}
          >
            Descargar
          </Button>
        </Grid>
      </Grid>
    </>
  )
}
